export const VERSION_MANAGEMENT_DEFAULT = 'system-default';
export const DAY_2_OPS_DEFAULT = 'system-default';
